export var buildPages = function buildPages(totalPages, activePage, ellipsisMarker) {
  // if 6 pages or less show them all
  if (totalPages <= 6) {
    return Array.from({
      length: totalPages
    }, function (_, i) {
      return i + 1;
    }); // more than 6 pages
  } else {
    // active page is in first four
    if (activePage <= 4) {
      return [1, 2, 3, 4, 5, ellipsisMarker, totalPages]; // active page is in [5, lastPage - 4]
    } else if (activePage >= 5 && activePage <= totalPages - 4) {
      return [1, ellipsisMarker, activePage - 1, activePage, activePage + 1, ellipsisMarker, totalPages]; // active page is in [lastPage - 3, lastPage]
    } else if (activePage >= totalPages - 3) {
      return [1, ellipsisMarker, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      throw new Error('Unhandled pagination criteria');
    }
  }
};